import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type CityRecord = ResultOf<typeof cityRecordQuery>["city"];
export const cityRecordQuery = graphql(`
  query CityRecord($id: ID!) {
    city(id: $id) {
      ...CityFields
    }
  }
`);

graphql(`
  fragment CityFields on City {
    id
    name
    region
    slug
    state
    description
    timezone
    lat
    lng
    created_at
    updated_at
    hero_image_generation_id
    heroImage {
      ...MediaFields
    }
    heroImageGeneration {
      id
      image {
        ...MediaFields
      }
    }
  }
`);
